module.exports = __webpack_public_path__ + "static/media/jusikon.64a8c5dc.png";